import NavBarActions from '@/components/navigation/NavBarActions';
import NavigationButtons from '@/components/navigation/NavigationButtons';
import { useThemeMode } from '@/hooks/useThemeMode';
import { AnalyticsPage } from '@/types/analytics';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AppBar, Box, Stack, Toolbar, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

type AnalyticsAppBarProps = {
  page: AnalyticsPage;
  setPage: (page: AnalyticsPage) => void;
};

const AnalyticsAppBar: FC<AnalyticsAppBarProps> = ({ page, setPage }) => {
  const { mode } = useThemeMode();
  const theme = useTheme();
  const appBarColor = theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[200];

  return (
    <AppBar
      position='relative'
      elevation={0}
      sx={{
        bgcolor: appBarColor,
        color: theme.palette.getContrastText(appBarColor)
      }}
    >
      <Toolbar
        variant='dense'
        sx={{
          gap: 0,
          flexDirection: 'column'
        }}
        disableGutters
      >
        <Stack direction='row' height='100%' minHeight={44} width='100%' alignItems='center' pl={1} pr={2}>
          <NavigationButtons />
          <Typography
            variant='h6'
            color='inherit'
            component='div'
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {page !== 'Call List' && (
              <Box display={'flex'} mr={1} sx={{ cursor: 'pointer' }} onClick={() => setPage('Call List')}>
                <ArrowBackIcon />
              </Box>
            )}
            {page ?? 'Block Engine Analytics'}
          </Typography>
          <NavBarActions />
        </Stack>
        <Box
          sx={{
            height: mode === 'light' ? theme.spacing(0.5) : theme.spacing(0.25),
            width: '100%',
            bgcolor: 'primary.main'
          }}
        />
      </Toolbar>
    </AppBar>
  );
};

export default AnalyticsAppBar;
